module.exports = __webpack_public_path__ + "static/media/track-order.9afce738.png";